import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';
import { action, computed, observable } from 'mobx';
import { HistoryFilter, SiteFilter } from 'services/pangolin/types';
import {
  createSiteFilterOptions,
  getSiteFilterID,
} from 'ui/history/site_entry/site_entry_logic';
import { notUndefined } from 'ui/base/types';

import { DomainInputStore } from './domain_input_modal/domain_input_store';
import { AddressInputStore } from './address_input_modal/address_input_store';
import { RangeInputStore } from './range_input_modal/range_input_store';
import { NetworkInputStore } from './network_input_modal/network_input_store';

export class SiteInputStore {
  search: SearchInputStore;
  domain: DomainInputStore;
  address: AddressInputStore;
  range: RangeInputStore;
  network: NetworkInputStore;

  @observable.shallow entries: SiteFilter[];
  @observable.shallow options: readonly SiteFilter[];

  constructor(filter: HistoryFilter) {
    this.search = new SearchInputStore();
    this.domain = new DomainInputStore();
    this.address = new AddressInputStore();
    this.range = new RangeInputStore();
    this.network = new NetworkInputStore();

    const entries = filter.sites;

    this.entries = entries;
    this.options = createSiteFilterOptions(entries);
  }

  @action.bound
  commitEntry(entry: SiteFilter): void {
    this.entries.push(entry);
  }

  @action.bound
  removeEntry(entry: SiteFilter): void {
    const id = getSiteFilterID(entry);
    const index = this.entries.findIndex(e => getSiteFilterID(e) === id);
    if (index >= 0) {
      this.entries.splice(index, 1);
    }
  }

  @action.bound
  commitDomain() {
    const entry = this.domain.commit();
    if (entry == null) {
      return;
    }
    this.entries.push(entry);
    this.domain.hideModal();
    this.search.modal.hideModal();
  }

  @action.bound
  commitAddress() {
    const entry = this.address.commit();
    if (entry == null) {
      return;
    }
    this.entries.push(entry);
    this.address.hideModal();
    this.search.modal.hideModal();
  }

  @action.bound
  commitRange() {
    const entry = this.range.commit();
    if (entry == null) {
      return;
    }
    this.entries.push(entry);
    this.range.hideModal();
    this.search.modal.hideModal();
  }

  @action.bound
  commitNetwork() {
    const entry = this.network.commit();
    if (entry == null) {
      return;
    }
    this.entries.push(entry);
    this.network.hideModal();
    this.search.modal.hideModal();
  }

  @computed
  get siteFilters(): SiteFilter[] {
    return this.entries.filter(notUndefined);
  }
}
